import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';
import Close from '../../../images/newDesign/closeBlack.svg';
import { StyledNoticeModal } from './NoticeModal.styled';

const NoticeModal = ({ showModal, onHide }) => {
    const { t } = useTranslation();

    return (
        <StyledNoticeModal
            centered
            show={showModal}
            onHide={onHide}
            size="xs"
        >
            <img src={Close} alt="close" className='close-btn' onClick={onHide} />
            
            <div className='notice-modal-title'>{t('payments.notice')}</div>

            <div className='notice-modal-info'>{t('payments.notice_info')}</div>

            <Button onClick={onHide}>{t('expenses.set_expenses.continue')}</Button>
        </StyledNoticeModal>
    )
}

export default NoticeModal;